<template>
  <div
    v-if="channels && loaded"
    class="c-epg-list"
  >
    <div class="c-epg-list__nav js-epg-nav">
      <div class="c-epg-list__header">
        <h1>{{ staticHeaderText || $t('glossary.epgCatalog') }}</h1>
      </div>
    </div>
    <div class="c-epg-list__items">
      <template v-for="channel in channels">
        <v-epg-list-item
          v-if="isNotEmptyEvent(channel)"
          :key="channel.id"
          :channel="channel"
          :filter="filter"
        ></v-epg-list-item>
      </template>
    </div>
  </div>
</template>
<script>
  import { fillProgramsMixin } from '@/shared/mixins';
  import { getNearestProgram, link } from '@/index/shared/filters';
  import VEpgListItem from './epg-list-item.vue';

  export default {
    name: 'VEpgList',
    components: {
      VEpgListItem,
    },
    filters: {
      link,
      getNearestProgram,
    },
    mixins: [
      fillProgramsMixin,
    ],
    props: {
      channels: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
      opts: {
        type: Object,
        default: () => ({}),
      },
      staticHeader: {
        type: Boolean,
        default: false,
      },
      staticHeaderText: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        filter: undefined,
        time: this.$services.resolve('time'),
        loaded: false,
      };
    },
    mounted() {
      this.load();
    },
    methods: {
      load() {
        this.fillPrograms(this.channels).then(() => {
          for (let i = 0, max = this.channels.length; i < max; i++) {
            const currentChannel = this.channels[i];
            const channel = this.manager.channels.collection.byId[currentChannel.id];
            currentChannel.programs = this.manager.getSince(this.epgTime, {
              since: this.time.now.clone().startOf('day'),
              till: this.time.now.clone().endOf('day'),
            }, channel);

            if (currentChannel.event) {
              currentChannel.nearestProgram = getNearestProgram(currentChannel.programs, this.epgTime.now.valueOf());
            }

            this.loaded = true;
          }
        });
      },
      isNotEmptyEvent(channel) {
        return !channel.event || channel.nearestProgram;
      },
      updateFilter(category = {}) {
        this.filter = category.id;
      },
    },
  };
</script>
